/**
 * Navbar burger
 * 
 * @link https://bulma.io/documentation/components/navbar/#navbar-menu
 */
let burgers = document.querySelectorAll('.navbar-burger');

burgers.forEach((burger) => {
    const data = burger.getAttribute('aria-controls');
    const target = document.getElementById(data);
    const parent = burger.parentElement;
    const pageNav = burger.closest('nav');
    const labelOpen = burger.dataset.labelOpen;
    const labelClose = burger.dataset.labelClose;

    const setMenuState = (active) => {
        burger.classList.toggle('is-active', active);
        burger.setAttribute('aria-expanded', active);
        burger.setAttribute('aria-label', active ? labelClose : labelOpen);
        target.classList.toggle('is-active', active);
        parent.classList.toggle('has-active-menu', active);
        pageNav.classList.toggle('is-fixed-top', active);
    };

    burger.addEventListener('click', () => {
        setMenuState(!burger.classList.contains('is-active'));
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape')
            setMenuState(false);
    });
});



/** 
 * Contact
 */
document.querySelectorAll('#form-contact .participant, #form-block-card .participant').forEach(participant => {
    const btn = participant.querySelector('.wp-block-button__link');
    const countryBox = participant.querySelector('.countries');
    const countrySelect = participant.querySelector('.countries select');
    const contacts = participant.querySelector('.contacts');

    btn.addEventListener('click', () => {
        countryBox.style.display = 'block';
        btn.style.display = 'none';
    });

    countrySelect.addEventListener('change', e => {
        const selected = e.target.value;

        contacts.style.display = 'block';

        contacts.querySelectorAll('.result').forEach(r => {
            r.style.display = 'none';
        });

        const active = contacts.querySelector(`.result.${selected}`);

        if (active) {
            active.style.display = 'flex';
        }
    });

});
